import { PartnerInquiry } from "@models";
import requests from "./agent";

export const contactService = {
  submitPartnerInquiry: async (inquiry: PartnerInquiry) => {
    await requests.post("/api/PartnerInquiry/Submit", inquiry);
  },
};
